<cb-dialog dialogHeading="{{ isEdit() ? 'Edit Quote' : 'Create Quote' }}">
    <form class="flex-col flex" #itemForm="ngForm" id="itemForm">
        @if (!isRequiredQuote && displayLotConceptWarning) {
            <cb-info-message
                [message]="'This Lot is not currently locked.'"
                [icon]="'warning'"
                [iconClass]="'mat-warn'"
            ></cb-info-message>
        }
        <div class="start-center flex-row flex">
            <cb-business-account-autocomplete-scroller
                class="cb-margin-right flex"
                label="Supplier"
                name="supplierSearch"
                [(ngModel)]="selectedSupplier"
                [required]="true"
                [requireMatch]="!isRequiredQuote"
                [matchProps]="['id']"
                (searchTextChanged)="supplierSearchTextChanged($event)"
                (optionSelected)="supplierSelected()"
                [status]="expectedStatuses"
                [displayNonActiveStatus]="true"
            >
            </cb-business-account-autocomplete-scroller>
        </div>
        @if (isRequiredQuote) {
            <cb-datepicker
                name="requiredDate"
                [(ngModel)]="mappedItem.requiredDate"
                [required]="true"
                label="Required By"
                [pickerType]="'calendar'"
            ></cb-datepicker>
        }
        <div class="start-center flex-row layoutGap-10">
            @if (!isRequiredQuote) {
                <cb-datepicker
                    class="flex"
                    name="quoteDate"
                    [(ngModel)]="mappedItem.quoteDate"
                    [required]="true"
                    label="Quote Date"
                    [pickerType]="'calendar'"
                ></cb-datepicker>
            }
            <cb-datepicker
                class="flex"
                name="expiryDate"
                [(ngModel)]="mappedItem.expiryDate"
                label="Expiry Date"
                [pickerType]="'calendar'"
            ></cb-datepicker>
            <button
                mat-icon-button
                matTooltip="Clear Expiry Date"
                (click)="mappedItem.expiryDate = null"
            >
                <mat-icon>delete_sweep</mat-icon>
            </button>
        </div>
        @if (!isRequiredQuote) {
            <cb-input
                type="text"
                name="quoteNumber"
                label="Quote Number"
                [maxlength]="100"
                [required]="true"
                [(ngModel)]="mappedItem.quoteNumber"
            ></cb-input>
        }
        @if (!isRequiredQuote) {
            <cb-currency
                class="flex"
                label="Quote Total (GST Exclusive)"
                type="number"
                name="quoteTotal"
                [required]="true"
                [(ngModel)]="mappedItem.quoteTotal"
            >
            </cb-currency>
        }
        <cb-text-area
            label="Description - Appears on Quote Cards and Change Records generated for this Quote"
            name="reasonDescription"
            [maxlength]="512"
            [required]="true"
            [(ngModel)]="mappedItem.description"
        >
        </cb-text-area>
        @if (!isRequiredQuote) {
            <cb-select
                [required]="true"
                name="changeSource"
                label="Change Source"
                [options]="changeSourcesLookup"
                [(ngModel)]="mappedItem.changeSource"
            >
            </cb-select>
        }
        @if (!displayLotConceptWarning) {
            <cb-checkbox
                [(ngModel)]="mappedItem.changeRecordRequired"
                name="changeRecordRequired"
                label="Change Record Required?"
                [readonly]="!canSkipChangeRecordCreation()"
            ></cb-checkbox>
        }
        @if (mappedItem.changeRecordRequired) {
            <span>
                <span class="cb-field-label cb-margin-bottom cb-required"
                    >Does this quote need to be shown as multiple lines on the variation?</span
                >
                <mat-radio-group
                    class="cb-margin-top flex-col"
                    name="createMultipleChangeRecords"
                    [(ngModel)]="mappedItem.createMultipleChangeRecords"
                    [required]="true"
                >
                    <mat-radio-button [value]="true">Yes</mat-radio-button>
                    <mat-radio-button [value]="false">No</mat-radio-button>
                </mat-radio-group>
            </span>
        }
        @if (!isRequiredQuote) {
            <div class="cb-margin-bottom cb-margin-top flex-col">
                <span class="cb-field-label cb-margin-bottom cb-required">Upload Document</span>
                <cb-drag-and-drop-document
                    class="cb-margin-bottom"
                    *cbWaitFor="documentEntity"
                    [(documentEntityMappedItem)]="documentEntity"
                    [showExistingDocumentInfo]="showExistingDocumentInfo()"
                >
                </cb-drag-and-drop-document>
            </div>
        }
    </form>
    <div actions>
        <button
            mat-raised-button
            color="primary"
            (cbClick)="save()"
            [clickLimit]="1"
            [disabled]="itemForm.invalid || (!isDocumentUploaded() && !isRequiredQuote)"
        >
            {{ isEdit() ? 'Update' : 'Create' }}
        </button>
        <button mat-raised-button (cbClick)="cancel()">Cancel</button>
    </div>
</cb-dialog>
